import { render } from "./RentPrintPage2.vue?vue&type=template&id=3857194d&scoped=true"
import script from "./RentPrintPage2.vue?vue&type=script&lang=js"
export * from "./RentPrintPage2.vue?vue&type=script&lang=js"

import "./RentPrintPage2.vue?vue&type=style&index=0&id=3857194d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3857194d"]])

export default __exports__